import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Users, User as UserIcon, ChevronDown } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "./ui/dropdown-menu";

/**
 * Vises i headeren rett ved siden av brukermenyen når brukeren har en aktiv
 * par-tilknytning (enten role=couple eller linked_couple_id). Lar brukeren
 * raskt bytte mellom å poste som seg selv eller som paret.
 */
export default function PostContextSwitcher() {
  const { user, linkedCouple, postingAsCoupleId, setPostingAsCoupleId } = useAuth();

  if (!user || user === false || !linkedCouple) return null;

  const postingAsCouple = !!postingAsCoupleId && postingAsCoupleId === linkedCouple.id;
  const label = postingAsCouple ? linkedCouple.name : user.username;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="hidden md:flex items-center gap-2 px-3 py-1.5 border border-white/15 rounded-sm text-xs font-meta hover:border-[var(--magenta)]/60 transition-colors"
          data-testid="post-context-switcher-trigger"
          title="Velg post-kontekst"
        >
          {postingAsCouple ? <Users className="h-3 w-3 text-[var(--magenta)]" /> : <UserIcon className="h-3 w-3" />}
          <span className="text-[var(--cream)]">{label}</span>
          <ChevronDown className="h-3 w-3 opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[var(--noir-elev)] border-white/10 text-[var(--cream)] w-64 rounded-sm">
        <DropdownMenuLabel className="font-meta text-[10px] text-[var(--cream-soft)]">
          POSTER SOM
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-white/10" />
        <DropdownMenuItem
          onClick={() => setPostingAsCoupleId(null)}
          className={`font-manrope text-xs cursor-pointer ${!postingAsCouple ? "text-[var(--magenta)]" : ""}`}
          data-testid="ctx-switch-single"
        >
          <UserIcon className="h-3.5 w-3.5 mr-2" />
          <div className="flex-1">
            <div className="text-sm">@{user.username}</div>
            <div className="text-[10px] text-[var(--cream-faint)]">Som meg selv</div>
          </div>
          {!postingAsCouple && <span className="text-[var(--magenta)] text-xs">●</span>}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setPostingAsCoupleId(linkedCouple.id)}
          className={`font-manrope text-xs cursor-pointer ${postingAsCouple ? "text-[var(--magenta)]" : ""}`}
          data-testid="ctx-switch-couple"
        >
          <Users className="h-3.5 w-3.5 mr-2" />
          <div className="flex-1">
            <div className="text-sm">{linkedCouple.name}</div>
            <div className="text-[10px] text-[var(--cream-faint)]">Som paret</div>
          </div>
          {postingAsCouple && <span className="text-[var(--magenta)] text-xs">●</span>}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
